import axios from "axios";

axios.defaults.baseURL = `${process.env.REACT_APP_API_BASE_URL}`;
// axios.defaults.baseURL = "http://118.27.5.175/api";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

export default axios;
